module.exports = __webpack_public_path__ + "static/img/zhengqingsheng.dd43cc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mingpian/zhengqingsheng.png
// module id = TFGL
// module chunks = 0